import { useFormik } from 'formik'
import React, {useContext, SetStateAction, ChangeEvent, useState} from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import useCallRestApi from '../../../hooks/useCallRestApi'
import { BodyContext } from '../../../contexts/BodyProvider'

type Props = {
    show: boolean,
    closeModal: (value: boolean) => void,
    setCardsBI: React.Dispatch<SetStateAction<CardsConectaBI[]>>
    cardsBI: CardsConectaBI[]
    categoriesBI: CategoryBI[]
}

function ModalEditCardBI({show, closeModal, setCardsBI, cardsBI, categoriesBI}: Props) {
  const [editImage, setEditImage] = useState("")
  const { modalCardValue, loadingAdminBIValue } = useContext(BodyContext);
  const [chooseCategory, setChooseCategory] = useState(0);
  const [infoCategory, setInfoCategory] = useState<CategoryBI>();
  const [conectaApi] = useCallRestApi()

  const formikEditCardBI = useFormik({
    initialValues: {
        id: modalCardValue!.modalCard![0].id as number,
        title: modalCardValue!.modalCard![0].title as string,
        description: modalCardValue!.modalCard![0].description as string,
        icon: modalCardValue!.modalCard![0].icon as string,
        url: modalCardValue!.modalCard![0].url as string,
        management: modalCardValue!.modalCard![0].management as string,
        developers: modalCardValue!.modalCard![0].developers as string,
        supervisor: modalCardValue!.modalCard![0].supervisor as string,
        managerName: modalCardValue!.modalCard![0].managerName as string,
        color: modalCardValue!.modalCard![0].color as string,
        CategoryId: modalCardValue!.modalCard![0].CategoryId as number
    },
    onSubmit: values => {
        //console.log(JSON.stringify(values, null, 2))
        //If the icon field is not filled in, it does not update, if the icon is filled in, it changes the icon
        formikEditCardBI.values.icon = editImage.length === 0 ? modalCardValue!.modalCard![0].icon as string : editImage as string
        //If the category field is not changed, it does not update, otherwise it updates to the new category
        formikEditCardBI.values.CategoryId = infoCategory?.id === undefined ? modalCardValue!.modalCard![0].Categoryid : infoCategory?.id as number
        //If the category is not changed, the color is not changed, otherwise, it updates to the color of the chosen category
        formikEditCardBI.values.color = infoCategory?.id === undefined ? modalCardValue!.modalCard![0].color as string : infoCategory?.color as string

        console.log(JSON.stringify(values, null, 2))
        const link: ResourceLink = {
            href: `api/card_bi/${modalCardValue!.modalCard![0].id}`,
            rel: "Atualizar",
            type: "PUT",
          };
           conectaApi<CardsConectaBI>({
            link,
            resource: values,
            onSuccess: () => {
                loadingAdminBIValue?.setLoadingAdminBI(true)
                renderList()
                loadingAdminBIValue?.setLoadingAdminBI(false)
                handleClose()
                
            },
            onError: (err: ErrorApi) => {},
            onFinally: () => {
              //msg
            },
          })
    }
})

const renderList = () => { 
    const link: ResourceLink = {
      href: `api/card_bi`,
      rel: "search",
      type: "GET",
    };

    conectaApi<CardsConectaBI[]>({
      link,
      onSuccess: (cardBI: CardsConectaBI[]) => {
        setCardsBI(cardBI);
      },
      onError: (err: ErrorApi) => {},
      onFinally: () => {},
    });
  };

  const handleImage = (e: ChangeEvent<HTMLInputElement>) => {
    if(e.target.files){
         const file = e.target.files[0]

         const reader =  new FileReader()

         reader.addEventListener(
            "load",
            () => {
                let base = reader.result
                setEditImage(base as string)                
            },
            false
         )
        
         if(file) {
            reader.readAsDataURL(file)
         }
    }
}

//Secure the category id
const handlerChooseCategory = (value: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = value.target.value;
    setChooseCategory(parseInt(newValue));
    const filterInfo = categoriesBI.filter((cat) => cat.id === parseInt(newValue))
    setInfoCategory(filterInfo[0])
}

 const filterCategory = categoriesBI.filter(category => category.id === modalCardValue!.modalCard![0].CategoryId)
 const handleClose = () => closeModal(false)

  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Editar Cards BI</Modal.Title>
        </Modal.Header>
        <Form onSubmit={formikEditCardBI.handleSubmit}>
            <Modal.Body>
            <Form.Group>
                <Form.Label>Categoria</Form.Label>
                <Form.Select value={chooseCategory} onChange={(value) => handlerChooseCategory(value)}>
                    <option value={filterCategory[0]?.id}>{filterCategory[0]?.name}</option>
                    {categoriesBI && categoriesBI.map((category) => (
                        <option key={category.id} value={category.id}>{category.name}</option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Group>
                <Form.Label>Icone</Form.Label>
                    <Form.Control
                        type='file'
                        name="icon"
                        accept='image/*'
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleImage(e)}
                    />
            </Form.Group>
                <Form.Group>
                    <Form.Label>Titulo</Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        placeholder="Titulo do card"
                        value={formikEditCardBI.values.title}
                        onChange={formikEditCardBI.handleChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Titulo Completo</Form.Label>
                    <Form.Control
                        type="text"
                        name="description"
                        value={formikEditCardBI.values.description}
                        onChange={formikEditCardBI.handleChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>URL</Form.Label>
                    <Form.Control
                        type="text"
                        name="url"
                        placeholder="Endereço da aplicação"
                        value={formikEditCardBI.values.url}
                        onChange={formikEditCardBI.handleChange}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type="submit">Atualizar</Button>
                <Button variant="danger" onClick={handleClose}> Fechar</Button>
            </Modal.Footer>
        </Form>
    </Modal>
  )
}

export default ModalEditCardBI